import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { AdminCampaignTypes } from '../types';
import CampaignRow from './CampaignRow';

interface Props {
  data: AdminCampaignTypes[];
  loadMore: () => void;
  hasMore: boolean;
}

const colWidths = [
  'min-w-[56px]', 'min-w-[60px]', 'min-w-[150px]', 'min-w-[210px]',
  'min-w-[100px]', 'min-w-[100px]', 'min-w-[100px]', 'min-w-[104px]', 'min-w-[48px]',
];

const headers = [
  'Image', 'Timestamp', 'Gamic Title', 'Date Range',
  'Budget', 'Spent', 'Total Impression', 'Status', 'Action',
];

const CampaignTable: React.FC<Props> = ({ data, loadMore, hasMore }) => (
  <div className="relative h-full">
    <div id="campaign-scroll" className="absolute inset-0 scrollbar scrollbar-thumb-[#EEEEEE] scrollbar-track-transparent overflow-auto">
      <InfiniteScroll
        dataLength={data.length}
        next={loadMore}
        hasMore={hasMore}
        loader={<div className="p-4 text-center text-sm">Loading…</div>}
        scrollableTarget="campaign-scroll"
        className="!overflow-visible"
      >
        <table className="min-w-full table-fixed text-left">
          <colgroup>
            {colWidths.map((w, i) => (
              <col key={i} className={w} />
            ))}
          </colgroup>
          <thead className="sticky top-0 z-10 bg-white border-b">
            <tr>
              {headers.map((h, i) => (
                <th key={i} className={`px-4 py-[18px] font-bold whitespace-nowrap ${i === headers.length - 1 ? 'pr-[21px]' : ''}`}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((campaign) => (
              <CampaignRow key={campaign.id} campaign={campaign} />
            ))}
          </tbody>
        </table>
      </InfiniteScroll>
    </div>
  </div>
);

export default CampaignTable;
